// Tek ikon seti: aynı 24'lük kutu, aynı 1.6 stroke, aynı uçlar. Emoji yok
// (10-TASARIM-V2: "Simge gerekiyorsa tek SVG seti, aynı stroke ve ölçü").

const NS = 'http://www.w3.org/2000/svg';

function svg(paths: string[], opts: { fill?: boolean } = {}): SVGSVGElement {
  const node = document.createElementNS(NS, 'svg');
  node.setAttribute('viewBox', '0 0 24 24');
  node.setAttribute('aria-hidden', 'true');
  node.setAttribute('focusable', 'false');
  if (opts.fill) {
    node.setAttribute('fill', 'currentColor');
  } else {
    node.setAttribute('fill', 'none');
    node.setAttribute('stroke', 'currentColor');
    node.setAttribute('stroke-width', '1.6');
    node.setAttribute('stroke-linecap', 'round');
    node.setAttribute('stroke-linejoin', 'round');
  }
  for (const d of paths) {
    const p = document.createElementNS(NS, 'path');
    p.setAttribute('d', d);
    node.appendChild(p);
  }
  return node;
}

function skipIcon(forward: boolean): SVGSVGElement {
  const node = svg(forward
    ? ['M18 7A8 8 0 1 0 20 14', 'M18 3v4h4']
    : ['M6 7A8 8 0 1 1 4 14', 'M6 3v4H2']);
  const label = document.createElementNS(NS, 'text');
  label.setAttribute('x', '12');
  label.setAttribute('y', '16');
  label.setAttribute('text-anchor', 'middle');
  label.setAttribute('fill', 'currentColor');
  label.setAttribute('stroke', 'none');
  label.setAttribute('font-size', '8');
  label.setAttribute('font-weight', '700');
  label.textContent = '10';
  node.appendChild(label);
  return node;
}

export const icon = {
  search: () => svg(['M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z', 'm20 20-4.2-4.2']),
  compass: () => svg(['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z', 'm15.2 8.8-1.9 4.5-4.5 1.9 1.9-4.5 4.5-1.9Z']),
  broadcast: () => svg([
    'M12 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6Z',
    'M7.8 7.8a6 6 0 0 0 0 8.4', 'M16.2 16.2a6 6 0 0 0 0-8.4',
    'M5 5a9.9 9.9 0 0 0 0 14', 'M19 19a9.9 9.9 0 0 0 0-14',
  ]),
  list: () => svg(['M4 6.5h16', 'M4 12h16', 'M4 17.5h10']),
  film: () => svg(['M3.5 5.5h17v13h-17z', 'M8 5.5v13', 'M16 5.5v13', 'M3.5 12h17']),
  series: () => svg(['M3.5 6.5h17v11h-17z', 'M8.5 21h7', 'M12 17.5V21']),
  user: () => svg(['M12 4.5a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2Z', 'M5 19.5a7 7 0 0 1 14 0']),
  star: () => svg(['m12 4.6 2.3 4.7 5.2.8-3.8 3.6.9 5.1-4.6-2.4-4.6 2.4.9-5.1L4.5 10l5.2-.8L12 4.6Z']),
  starFilled: () => svg(['m12 4.6 2.3 4.7 5.2.8-3.8 3.6.9 5.1-4.6-2.4-4.6 2.4.9-5.1L4.5 10l5.2-.8L12 4.6Z'], { fill: true }),
  play: () => svg(['M8 5.5v13l11-6.5-11-6.5Z'], { fill: true }),
  pause: () => svg(['M8.5 5.5h3v13h-3z', 'M12.5 5.5h3v13h-3z'], { fill: true }),
  back10: () => skipIcon(false),
  fwd10: () => skipIcon(true),
  volume: () => svg(['M4.5 9.5h3.2L12 6v12l-4.3-3.5H4.5z', 'M16 9.6a3.4 3.4 0 0 1 0 4.8', 'M18.6 7.2a7 7 0 0 1 0 9.6']),
  volumeOff: () => svg(['M4.5 9.5h3.2L12 6v12l-4.3-3.5H4.5z', 'm16 10 4 4', 'm20 10-4 4']),
  expand: () => svg(['M4.5 9V4.5H9', 'M15 4.5h4.5V9', 'M19.5 15v4.5H15', 'M9 19.5H4.5V15']),
  arrowLeft: () => svg(['M19 12H5', 'm11 5-6 7 6 7']),
  arrowRight: () => svg(['M5 12h14', 'm13 5 6 7-6 7']),
  arrowUpRight: () => svg(['M7.5 16.5 16.5 7.5', 'M9 7.5h7.5V15']),
  lock: () => svg(['M5.8 10.5h12.4v9H5.8z', 'M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5']),
  settings: () => svg([
    'M12 9.3a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 0 0 0-5.4Z',
    'M19.4 14.2a1.4 1.4 0 0 0 .3 1.5l.1.1a1.7 1.7 0 1 1-2.4 2.4l-.1-.1a1.4 1.4 0 0 0-1.5-.3 1.4 1.4 0 0 0-.9 1.3v.2a1.7 1.7 0 1 1-3.4 0v-.1a1.4 1.4 0 0 0-.9-1.3 1.4 1.4 0 0 0-1.5.3l-.1.1a1.7 1.7 0 1 1-2.4-2.4l.1-.1a1.4 1.4 0 0 0 .3-1.5 1.4 1.4 0 0 0-1.3-.9h-.2a1.7 1.7 0 1 1 0-3.4h.1a1.4 1.4 0 0 0 1.3-.9 1.4 1.4 0 0 0-.3-1.5l-.1-.1a1.7 1.7 0 1 1 2.4-2.4l.1.1a1.4 1.4 0 0 0 1.5.3h.1a1.4 1.4 0 0 0 .9-1.3v-.2a1.7 1.7 0 1 1 3.4 0v.1a1.4 1.4 0 0 0 .9 1.3 1.4 1.4 0 0 0 1.5-.3l.1-.1a1.7 1.7 0 1 1 2.4 2.4l-.1.1a1.4 1.4 0 0 0-.3 1.5v.1a1.4 1.4 0 0 0 1.3.9h.2a1.7 1.7 0 1 1 0 3.4h-.1a1.4 1.4 0 0 0-1.3.9Z',
  ]),
  card: () => svg(['M3.5 6.5h17v11h-17z', 'M3.5 10.5h17']),
  chart: () => svg(['M4.5 19.5h15', 'M7 16v-5', 'M12 16V7', 'M17 16v-8']),
  logout: () => svg(['M10 4.5H5.5v15H10', 'M15 8.5l3.5 3.5L15 15.5', 'M18 12H9.5']),
  antenna: () => svg(['M12 12v8', 'M8 20h8', 'm6.5 3.5 5.5 8 5.5-8', 'M8.7 7.2h6.6']),
  image: () => svg(['M3.5 5.5h17v13h-17z', 'M3.5 15.5l4.5-4 4 3.5 3-2.5 5 4.5', 'M8.7 9.6a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z']),
  check: () => svg(['m5 12.5 4.5 4.5L19 7']),
  plus: () => svg(['M12 5v14', 'M5 12h14']),
  /** Pakette OLMAYAN madde: tikin karşılığı. */
  minus: () => svg(['M5 12h14']),
  chevronDown: () => svg(['m6 9.5 6 6 6-6']),
  close: () => svg(['m6 6 12 12', 'm18 6-12 12']),
  heart: () => svg(['M12 19.5S4.5 15 4.5 9.8A3.8 3.8 0 0 1 12 8a3.8 3.8 0 0 1 7.5 1.8c0 5.2-7.5 9.7-7.5 9.7Z']),
  info: () => svg(['M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Z', 'M12 11v5.5', 'M12 7.8h.01']),
  phone: () => svg(['M7.5 2.5h9v19h-9z', 'M10.5 18.8h3']),
  refresh: () => svg(['M20 6.5v5h-5', 'M4 17.5v-5h5', 'M19 11.5a7.2 7.2 0 0 0-12.4-3.2L4 11.5', 'M5 12.5a7.2 7.2 0 0 0 12.4 3.2L20 12.5']),
  trash: () => svg(['M4.5 6.5h15', 'M9.5 6.5V4.5h5v2', 'M6.5 6.5l1 13h9l1-13']),
};

export type IconName = keyof typeof icon;

export function iconEl(name: IconName): SVGSVGElement {
  return icon[name]();
}
